import React from "react";
import { KpointPlayerFromEmbedCode } from "../../lib/kpoint/KpointPlayerFromEmbedCode";

const RichTextRenderer = ({ content, styles }) => {
  const renderChildren = (children) => {
    return children?.map((child, index) => {
      if (child.type === "text") {
        let text = child.text || "";
        let subtext = child.text.includes("~") || "";

        if (child.bold) text = <strong key={index}>{text}</strong>;
        if (child.italic) text = <em key={index}>{text}</em>;
        if (child.underline) text = <u key={index}>{text}</u>;
        if (child.strikethrough) text = <del key={index}>{text}</del>;
        return (
          <>
            <span
              key={index}
              className={`${styles?.richText} ${
                subtext ? styles?.richTextIndent : ""
              }`}
            >
              {subtext ? text.slice(2) : text}
            </span>
          </>
        );
      } else if (child.type === "link") {
        return (
          <a key={index} href={child.url} className={styles?.richTextLink}>
            {renderChildren(child.children)}
          </a>
        );
      } else if (child.type === "code") {
        return (
          <code key={index} className={styles?.richTextCode}>
            {child.text}
          </code>
        );
      }
      return null;
    });
  };

  const handleCode = (block) => {
    return block?.children?.map((child, index) => {
      const embedCode = child.text || "";
      if (embedCode.includes("data-video-host")) {
        return (
          <KpointPlayerFromEmbedCode
            key={index}
            embedCode={embedCode}
            containerClassNames={styles?.videoAlignmentClass}
          />
        );
      } else {
        return (
          <code key={index} className={styles?.richTextCode}>
            {child.text}
          </code>
        );
      }
    });
  };

  const renderBlocks = () => {
    return content?.map((block, index) => {
      switch (block.type) {
        case "heading":
          return React.createElement(
            `h${block.level}`,
            { key: index, className: styles?.richTextHeading },
            renderChildren(block.children)
          );
        case "paragraph":
          return (
            <p key={index} className={styles?.richTextParagraph}>
              {renderChildren(block.children)}
            </p>
          );
        case "list":
          const listType = block.format === "ordered" ? "ol" : "ul";
          return (
            <React.Fragment key={index}>
              {React.createElement(
                listType,
                { className: styles?.richTextList },
                block.children.map((listItem, listIndex) => {
                  const hasIndent = listItem.children[0].text.includes("~");

                  return (
                    <>
                      {hasIndent ? (
                        <ul
                          className={styles.richTextUl}
                          style={{ marginBottom: "0px" }}
                        >
                          <li className={styles.richTextListItemIndent}>
                            {renderChildren(listItem.children)}
                          </li>
                        </ul>
                      ) : (
                        <li key={listIndex} className={styles.richTextListItem}>
                          {renderChildren(listItem.children)}
                        </li>
                      )}
                    </>
                  );
                })
              )}
            </React.Fragment>
          );
        case "quote":
          return (
            <blockquote key={index} className={styles?.richTextQuote}>
              {renderChildren(block.children)}
            </blockquote>
          );
        case "image":
          return (
            <img
              key={index}
              src={block.image.url}
              alt={block.image.alternativeText}
              className={styles?.richTextImage}
            />
          );
        case "code":
          return handleCode(block);
        default:
          return null;
      }
    });
  };

  return <div className={styles?.richTextContainer}>{renderBlocks()}</div>;
};

export default RichTextRenderer;
